import { render, staticRenderFns } from "./UpdateResourcePopup.vue?vue&type=template&id=5facda86&scoped=true"
import script from "./UpdateResourcePopup.vue?vue&type=script&lang=js"
export * from "./UpdateResourcePopup.vue?vue&type=script&lang=js"
import style0 from "./UpdateResourcePopup.vue?vue&type=style&index=0&id=5facda86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5facda86",
  null
  
)

export default component.exports